import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../../Components/consts'

export const SeasonTableCon = styled('div')(({ theme }) => ({
  overflowX: 'scroll',
  width: '100%',
  paddingBottom: 10,
}))

export const SeasonTable = styled('table')(({ theme }) => ({
  fontFamily: 'Roboto',
  fontWeight: 300,
  fontSize: fontSizes.small,
  borderCollapse: 'collapse',
  maxWidth: 500,
  '& tr': {
    height: theme.spacing(5),
  },
  '& .headRow': {
    fontSize: fontSizes.small,
    '& th': {
      textAlign: 'center',
      fontWeight: 'normal',
      '&:first-of-type': {
        textAlign: 'left',
        width: 60,
        position: 'sticky',
        left: 0,
        fontWeight: 'bold',
        zIndex: 9,
        backgroundColor: colors.white,
        [theme.breakpoints.down('md')]: {
          width: 40,
        },
      },
      '&:nth-of-type(2)': {
        position: 'sticky',
        left: 64,
        textAlign: 'left',
        minWidth: 80,
        fontWeight: 'bold',
        zIndex: 9,
        backgroundColor: colors.white,
        [theme.breakpoints.down('sm')]: {
          left: 44,
        },
      },
    },
  },
}))

export const SeasonDataRow = styled('tr')(({ theme }) => ({
  fontWeight: 'normal',
  borderBottom: `1px solid ${colors.lightestGrey}`,
  '&:last-child': {
    borderBottom: 0,
  },
  '& td': {
    width: '11%',
    verticalAlign: 'center',
    textAlign: 'center',
    minWidth: 60,
    paddingRight: 2,
    [theme.breakpoints.down('sm')]: {
      minWidth: 40,
    },
    '&:first-of-type': {
      textAlign: 'left',
      width: 60,
      fontWeight: 'bold',
      position: 'sticky',
      left: 0,
      zIndex: 9,
      backgroundColor: colors.white,
    },
    '&:nth-of-type(2)': {
      position: 'sticky',
      left: 64,
      textAlign: 'left',
      minWidth: 80,
      fontWeight: 'bold',
      zIndex: 9,
      backgroundColor: colors.white,
      [theme.breakpoints.down('md')]: {
        left: 44,
      },
    },
  },
}))

export const SeasonAveragesRow = styled('tr')(({ theme }) => ({
  fontWeight: 'bold',
  borderTop: `1px solid ${colors.lightestGrey}`,
  borderBottom: 0,
  '& td': {
    padding: `8px 0`,
    width: '11%',
    verticalAlign: 'bottom',
    textAlign: 'center',
    minWidth: 60,
    [theme.breakpoints.down('md')]: {
      minWidth: 40,
    },
    '&:first-of-type': {
      position: 'sticky',
      textAlign: 'left',
      width: 60,
      left: 0,
      zIndex: 9,
      backgroundColor: colors.white,
      [theme.breakpoints.down('md')]: {
        width: 40,
      },
    },
    '&:nth-of-type(2)': {
      position: 'sticky',
      left: 64,
      textAlign: 'left',
      minWidth: 80,
      fontWeight: 'bold',
      backgroundColor: colors.white,
      [theme.breakpoints.down('md')]: {
        left: 44,
      },
    },
  },
}))

export const GameLogTable = styled('table')(({ theme }) => ({
  fontFamily: 'Roboto',
  fontWeight: 300,
  fontSize: fontSizes.medium,
  borderCollapse: 'collapse',
  '& tr': {
    height: theme.spacing(5),
  },
  '& .headRow': {
    fontSize: fontSizes.small,
    '& th': {
      textAlign: 'center',
      fontWeight: 'normal',
      marginRight: 1,
      '&:first-of-type': {
        textAlign: 'left',
        paddingLeft: 5,
      },
    },
  },
}))

export const DataRow = styled('tr')(({ theme }) => ({
  fontWeight: 'normal',
  borderBottom: `1px solid ${colors.lightestGrey}`,
  '&:last-child': {
    borderBottom: 0,
  },
  '& td': {
    padding: `5px 3px`,
    width: '11%',
    verticalAlign: 'bottom',
    textAlign: 'center',
    minWidth: 60,
    [theme.breakpoints.down('md')]: {
      minWidth: 40,
    },
    '&:first-of-type': {
      width: '30%',
      minWidth: 160,
      textAlign: 'left',
      paddingLeft: 5,
    },
  },
}))

export const AveragesRow = styled('tr')(({ theme }) => ({
  fontWeight: 'bold',
  borderTop: `1px solid ${colors.lightestGrey}`,
  borderBottom: 0,
  '& td': {
    padding: `8px 0`,
    width: '11%',
    verticalAlign: 'bottom',
    textAlign: 'center',
    minWidth: 60,
    [theme.breakpoints.down('md')]: {
      minWidth: 40,
    },
    '&:first-of-type': {
      width: '30%',
      minWidth: 160,
      textAlign: 'left',
      paddingLeft: 5,
    },
  },
}))

export const EventCell = styled('td')(({ theme }) => ({
  fontWeight: 'normal',
  paddingRight: theme.spacing(2),
  '& a': {
    color: colors.blue,
    textDecoration: 'none',
  },
}))
